import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../common/form';

class ChunkReportForm extends Form {
	state = {
		data: { chunkSize: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		chunkSize: Joi.number().positive().min(2).required().label('Chunk Size'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.chunkSize);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				<h3 className="form-title">Chunk Report</h3>

				{this.renderInput({
					type: "number",
					name: 'chunkSize',
					label: 'How many parts do you want to split this report into?',
					placeholder: 'Enter Chunk Size',
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('proceed')}
				</div>
			</form>
		);
	}
}

export default ChunkReportForm;
